"use strict"
exports.__esModule = true;
exports.MarkerIconConfig = {
  name: 'MarkerIcon',
  height: 512,
  width: 512,
  svgPath: 'M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z',
  yOffset: 0,
  xOffset: 0,
};
exports.MarkerIcon = require('../createIcon').createIcon(exports.MarkerIconConfig);
exports["default"] = exports.MarkerIcon;